import React from 'react'
import {Link} from 'react-router-dom'

const rootPath = '/app/catalog'

const catalogTypes = {
  client: {
    name: 'client',
    title: 'Клиентская программа',
    link: `${rootPath}/client`,
    getCategoryLink: (categoryId) => `${rootPath}/client/${categoryId}`,
    currency: '₽',
    getCatalogTitle: (category) => category
      ? `${category.title} в клиентской программе`
      : 'Все товары клиентской программы',
    getSearchPlaceholder: (category) => category
      ? `Поиск в категории «${category.title}»`
      : 'Поиск по всем товарам клиентской программы',
    getRootSearchLink: () => <Link to={`${rootPath}/client`}>по всей клиентской программе</Link>
  },
  main: {
    name: 'main',
    title: 'Основная программа',
    link: `${rootPath}/main`,
    getCategoryLink: (categoryId) => `${rootPath}/main/${categoryId}`,
    currency: '₽',
    getCatalogTitle: (category) => category
      ? `${category.title} в основной программе`
      : 'Все товары основной программы',
    getSearchPlaceholder: (category) => category
      ? `Поиск в категории «${category.title}»`
      : 'Поиск по всем товарам основной программы',
    getRootSearchLink: () => <Link to={`${rootPath}/main`}>по всей основной программе</Link>
  },
  advance: {
    name: 'advance',
    title: 'Покупка за жетонные баллы',
    link: `${rootPath}/advance`,
    getCategoryLink: (categoryId) => `${rootPath}/advance/${categoryId}`,
    currency: 'Б',
    getCatalogTitle: (category) => category
      ? `${category.title} за жетонные баллы`
      : 'Все товары за жетонные баллы',
    getSearchPlaceholder: (category) => category
      ? `Поиск в категории «${category.title}»`
      : 'Поиск по всем товарам за жетонные баллы',
    getRootSearchLink: () => <Link to={`${rootPath}/advance`}>по всему каталогу покупок за жетонные баллы</Link>
  }
}

export default catalogTypes
